// SubcatchmentPatternsForm.jsx
import { useMemo } from "react"
import { Button } from '@mui/material'
import { UniversalDropDown } from "@fileops/swmm-react"
import "../../css/DemoCode.css"

/**
 * Subcatchment Patterns Form is a group of data inputs usually shown when clicking on Subcatchment->Patterns. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {JSON} fullModel The 'full' SWMM model that contains supporting data for this component.
 * @param {string} target The name of the object targetted by this form.
 * @returns UI for interactive swmm modeling.
 */
export default function SubcatchmentPatternsForm({model, setModel, fullModel, target}) {
  const patternIDs   = useMemo(() => Object.keys(fullModel.PATTERNS), [fullModel.PATTERNS])
  const patternTypes = ['DSTORE', 'INFIL', 'N-PERV']

  const updateValue = (val, type) => {
    if(model && model.PATTERN){
      setModel(prev => ({
        ...prev,
        PATTERN: {
          ...prev.PATTERN,
          [target]: {
            ...prev.PATTERN[target],
            [type]: val
          }
        }
      }))
    }
  }

  if(model){
    return(
    <>
      {(
        patternTypes.map((type)=>(
        <label className='editor-small' key={'Pattern'+target+type}>{type}
          <Button style={{padding: '0px', float:'right', display:'inline' }} color={'error'} onClick={()=>{updateValue('*', type)}}>CLEAR</Button>
          <UniversalDropDown style={{padding: '0'}}
            IDs={patternIDs} 
            selectText={"Select a Pattern"} 
            value={model.PATTERN[target][type]}
            onChange={(val)=>{updateValue(val, type)}} >
          </UniversalDropDown>
        </label>
        ))
      )}
    </>
    )
  } else {
    return null;
  }
}